import { render, staticRenderFns } from "./Campaigns.vue?vue&type=template&id=0be86987"
import script from "./Campaigns.vue?vue&type=script&lang=js"
export * from "./Campaigns.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/myskilliz_new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0be86987')) {
      api.createRecord('0be86987', component.options)
    } else {
      api.reload('0be86987', component.options)
    }
    module.hot.accept("./Campaigns.vue?vue&type=template&id=0be86987", function () {
      api.rerender('0be86987', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/views/rh/gestion/campaign/Campaigns.vue"
export default component.exports